
 
 

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { ArchwizardModule } from 'angular-archwizard';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
 
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { NgxPrintElementModule } from 'ngx-print-element';
 
import { NgApexchartsModule } from 'ng-apexcharts';
 
import { AgmCoreModule} from '@agm/core';
// **  
import {NgxPaginationModule} from 'ngx-pagination';

// cookie 
import { CookieService } from 'ngx-cookie-service'


import { DxReportViewerModule } from 'devexpress-reporting-angular';
import { ViewProductComponent } from './product/view-product/view-product.component';
import { ViewBranchComponent } from './Branch/view-branch/view-branch.component';
import { InsertBranchComponent } from './Branch/insert-branch/insert-branch.component';
import { ViewCityComponent } from './city/view-city/view-city.component';
import { InsertCityComponent } from './city/insert-city/insert-city.component';
import { ViewCountryComponent } from './country/view-country/view-country.component';
import { InsertCountryComponent } from './country/insert-country/insert-country.component';
import { ViewDonationCallRequestComponent } from './Donation-call-request/view-donation-call-request/view-donation-call-request.component';
import { InsertDonationCallRequestComponent } from './Donation-call-request/insert-donation-call-request/insert-donation-call-request.component';
import { ViewDonationCategoryComponent } from './Donation-category/view-donation-category/view-donation-category.component';
import { InsertDonationCategoryComponent } from './Donation-category/insert-donation-category/insert-donation-category.component';
import { ViewDonationMainTypeComponent } from './Donation-main-type/view-donation-main-type/view-donation-main-type.component';
import { InsertDonationMainTypeComponent } from './Donation-main-type/insert-donation-main-type/insert-donation-main-type.component';
import { DonationTypeComponent } from './Donation-type/view-donation-type/donation-type.component';
import { InsertDonationTypeComponent } from './Donation-type/insert-donation-type/insert-donation-type.component';
import { ViewEventComponent } from './Event/view-event/view-event.component';
import { InsertEventComponent } from './Event/insert-event/insert-event.component';
import { ViewGovernorateComponent } from './Governrate/view-governorate/view-governorate.component';
import { InsertGovernorateComponent } from './Governrate/insert-governorate/insert-governorate.component';
import { ViewJoinRequestComponent } from './join-request/view-join-request/view-join-request.component';
import { InsertJoinRequestComponent } from './join-request/insert-join-request/insert-join-request.component';
import { ViewJoinTypeComponent } from './join-type/view-join-type/view-join-type.component';
import { InsertJoinTypeComponent } from './join-type/insert-join-type/insert-join-type.component';
import { ViewNewsComponent } from './News/view-news/view-news.component';
import { InsertNewsComponent } from './News/insert-news/insert-news.component';
import { ViewPhotoComponent } from './photo/view-photo/view-photo.component';
import { InsertPhotoComponent } from './photo/insert-photo/insert-photo.component';
import { ViewPhotoAlbumComponent } from './photo-album/view-photo-album/view-photo-album.component';
import { InsertPhotoAlbumComponent } from './photo-album/insert-photo-album/insert-photo-album.component';
import { ViewSectorComponent } from './sector/view-sector/view-sector.component';
import { InsertSectorComponent } from './sector/insert-sector/insert-sector.component';
import { ViewSectorLocationComponent } from './sector-location/view-sector-location/view-sector-location.component';
import { InsertSectorLocationComponent } from './sector-location/insert-sector-location/insert-sector-location.component';
import { ViewSectorTypeComponent } from './sector-type/view-sector-type/view-sector-type.component';
import { InsertSectorTypeComponent } from './sector-type/insert-sector-type/insert-sector-type.component';
import { ViewUserComponent } from './User/view-user/view-user.component';
import { InsertUserComponent } from './User/insert-user/insert-user.component';
import { ViewVideoComponent } from './video/view-video/view-video.component';
import { InsertVideoComponent } from './video/insert-video/insert-video.component';
import { ViewVideoAlbumComponent } from './video-album/view-video-album/view-video-album.component';
import { InsertVideoAlbumComponent } from './video-album/insert-video-album/insert-video-album.component';
import { ChangePasswordComponent } from './User/change-password/change-password.component';
import { ViewKeywordsComponent } from './keywords/view-keywords/view-keywords.component';
import { InsertKeywordsComponent } from './keywords/insert-keywords/insert-keywords.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ListOurPartnersComponent } from './OurPartners/list-our-partners/list-our-partners.component';
import { InsertOurPartnersComponent } from './OurPartners/insert-our-partners/insert-our-partners.component';
import { ListProjectsComponent } from './Projects/Project/list-projects/list-projects.component';
import { InsertProjectComponent } from './Projects/Project/insert-project/insert-project.component';
import { InsertProjectAccomplishmentComponent } from './Projects/project-accomplishment/insert-project-accomplishment/insert-project-accomplishment.component';
import { ListProjectAccomplishmentComponent } from './Projects/project-accomplishment/list-project-accomplishment/list-project-accomplishment.component';
import { SuppliersComponent } from './suppliers/suppliers.component';
import { PartnerRequestComponent } from './partner-request/partner-request.component';
import { NGOrganizationsComponent } from './ngorganizations/ngorganizations.component';
import { InquiryComponent } from './inquiry/inquiry.component';
import { SupplierDetailsComponent } from './supplier-details/supplier-details.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgorganizationsDetailsComponent } from './ngorganizations-details/ngorganizations-details/ngorganizations-details.component';
import { EmploymentRequestListComponent } from './join-request/employment-request-list/employment-request-list.component';
import { VolunteeringRequestListComponent } from './join-request/volunteering-request-list/volunteering-request-list.component';
import { CoursesRequestListComponent } from './join-request/courses-request-list/courses-request-list.component';
import { JobRequestReportComponent } from './Report/job-request-report/job-request-report.component';
import { DonationsReportComponent } from './Report/donations-reports/donations-reports.component';
import { VoluntaryRequestReportComponent } from './Report/voluntary-request-report/voluntary-request-report.component';
import { TrainingCoursesReportComponent } from './Report/training-courses-report/training-courses-report.component';
import { NationalOrganizationReportComponent } from './Report/national-organization-report/national-organization-report.component';
import { PartnerRequestReportComponent } from './Report/partner-request-report/partner-request-report.component';
import { ReportsServiceComponent } from './Report/reports-service/reports-service.component';
import { InsertJobComponent } from './Job/insert-job/insert-job.component';
import { ListJobComponent } from './Job/list-job/list-job.component';
import { ListCampaignComponent } from './Campaign/list-campaign/list-campaign.component';
import { InsertCampaignComponent } from './Campaign/insert-campaign/insert-campaign.component';
import {OnlineDonationsStatsComponent} from './Stats/Online-Donations-Stats/Online-Donations-Stats.component'
import { AddOrUpdateGoldPriceComponent } from './GoldPrice/AddOrUpdateGoldPrice/AddOrUpdateGoldPrice.component';
import { CreateOrUpdateHomeImageComponent } from './HomeImage/create-or-update-home-image/create-or-update-home-image.component';
// import { DxReportViewerModule } from 'devexpress-angular/reporting/viewer';
import { DonationWayFileComponent } from "./DonationWayFile/DonationWayFile/DonationWayFile.component";

 @NgModule({
  declarations: [
    ViewProductComponent,
    ViewBranchComponent,
    InsertBranchComponent,
    ViewCityComponent,
    InsertCityComponent,
    ViewCountryComponent,
    InsertCountryComponent,
    ViewDonationCallRequestComponent,
    InsertDonationCallRequestComponent,
    ViewDonationCategoryComponent,
    InsertDonationCategoryComponent,
    ViewDonationMainTypeComponent,
    InsertDonationMainTypeComponent,
    DonationTypeComponent,
    InsertDonationTypeComponent,
    ViewEventComponent,
    InsertEventComponent,
    ViewGovernorateComponent,
    InsertGovernorateComponent,
    ViewJoinRequestComponent,
    InsertJoinRequestComponent,
    ViewJoinTypeComponent,
    InsertJoinTypeComponent,
    ViewNewsComponent,
    InsertNewsComponent,
    ViewPhotoComponent,
    InsertPhotoComponent,
    ViewPhotoAlbumComponent,
    InsertPhotoAlbumComponent,
    ViewSectorComponent,
    InsertSectorComponent,
    ViewSectorLocationComponent,
    InsertSectorLocationComponent,
    ViewSectorTypeComponent,
    InsertSectorTypeComponent,
    ViewUserComponent,
    InsertUserComponent,
    ViewVideoComponent,
    InsertVideoComponent,
    ViewVideoAlbumComponent,
    InsertVideoAlbumComponent,
    ChangePasswordComponent,
    ViewKeywordsComponent,
    InsertKeywordsComponent,
    ListOurPartnersComponent,
    InsertOurPartnersComponent,
    ListProjectsComponent,
    InsertProjectComponent,
    InsertProjectAccomplishmentComponent,
    ListProjectAccomplishmentComponent,
    SuppliersComponent,
    PartnerRequestComponent,
    NGOrganizationsComponent,
    InquiryComponent,
    SupplierDetailsComponent,
    NgorganizationsDetailsComponent,
    EmploymentRequestListComponent,
    VolunteeringRequestListComponent,
    CoursesRequestListComponent,
    JobRequestReportComponent,
    DonationsReportComponent,
    VoluntaryRequestReportComponent,
    TrainingCoursesReportComponent,
    NationalOrganizationReportComponent,
    PartnerRequestReportComponent,
    ReportsServiceComponent,
    InsertJobComponent,
    ListJobComponent,
    ListCampaignComponent,
    InsertCampaignComponent,
    OnlineDonationsStatsComponent,
    AddOrUpdateGoldPriceComponent,
    CreateOrUpdateHomeImageComponent,
    DonationWayFileComponent
  ],
  imports: [
    AngularEditorModule,
    PdfViewerModule,
    DxReportViewerModule,
    CommonModule,
    AdminRoutingModule,
    SharedModule,
    ArchwizardModule,
    SweetAlert2Module,
    NgxPaginationModule,
    RouterModule,
    NgApexchartsModule,
    // NgxPrintElementModule,
    NgMultiSelectDropDownModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey:'AIzaSyANjlA2OTWMRWUTUsu1D7ptP0D5PvW7U8E'
    })
   
  ],
  providers: [
   CookieService
  ],
  
  exports:[ ]
})

export class AdminModule { }
